import { Component, ViewChild, Input, HostListener, OnInit, OnDestroy } from '@angular/core';
import { NgxMasonryOptions } from 'ngx-masonry';
import { DataService } from '../../services/data.service';
import { Subscription } from 'rxjs';

export class MasonryItemModel {
    component: any;
    injector?: any;
    isExpanded ?: boolean;
    isExpandable ?: boolean;
}

@Component({
    selector: 'masonry',
    templateUrl: './masonry.component.html'
})
export class MasonryComponent implements OnInit, OnDestroy {

    @Input('masonryItems') masonryItems: MasonryItemModel[] = [];
    @Input('masonryColumnCount') masonryColumnCount: number = 2;

    subscriptions: Subscription[] = [];

    @ViewChild('masonry', { static: true }) masonry;
    masonryTransitionDelay: number = 0.2;
    masonryOptions: NgxMasonryOptions = {
        columnWidth: 20,
        itemSelector: '.masonry-item',
        gutter: 10,
        resize: true,
        initLayout: true,
        fitWidth: true,
        horizontalOrder: true
    };
    masonryColumnsEnabled: boolean = false;

    constructor(
        private dataService: DataService
    ) { }

    ngOnInit() {
        this.onResize();

        this.subscriptions.push(
            this.dataService.updateMasonry.subscribe(
                result => {
                    setTimeout(() => {
                        if (this.masonry) {
                            this.masonry._msnry.reloadItems();
                            this.masonry._msnry.layout();
                        }

                    }, this.masonryTransitionDelay * 1000);
                }
            )
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.masonryColumnsEnabled = window.innerWidth > 768;
    }

    toggleExpand(item: any, event: any) {
        let scrollTarget = event.currentTarget.offsetParent;
        if (!item.isExpanded && this.masonryItems.indexOf(item) > 0) {
            setTimeout(() => {
                let scrolltarget = scrollTarget.getBoundingClientRect().top;
                scrolltarget > 350 ? scrolltarget = scrolltarget / 2 : scrolltarget;

                try {
                    window.scrollTo({ left: 0, top: scrolltarget, behavior: 'smooth' });
                } catch (e) {
                    window.scroll(0, scrolltarget); // compatibility
                }
            }, this.masonryTransitionDelay + 0.1 * 1000);

            this.masonryItems.splice(this.masonryItems.indexOf(item), 1);
            this.masonryItems.unshift(item);
        }

        item.isExpanded = item.isExpanded ? false : true;

        setTimeout(() => {
            if (this.masonry) {
                this.masonry._msnry.reloadItems();
                this.masonry._msnry.layout();
            }

        }, this.masonryTransitionDelay * 1000);
    }
}
